import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'
import legal_entities from 'modules/core/store/collections/legalEntities'

interface IAccessGroupParent {
  legalEntityIds: number[]
}

interface LegalEntityMultiselectorProps {
  parent: IAccessGroupParent | undefined
  form: Form
}

const LegalEntityMultiselector = ({ parent, form }: LegalEntityMultiselectorProps) => {
  const [legalEntitiesIds, setLegalEntitiesIds] = React.useState(parent?.legalEntityIds ?? [])
  const handleChangeLegalEntities = (ids: number[]) => {
    setLegalEntitiesIds(ids)

    form.get('legal_entity_ids').set(ids)
  }

  const legalEntityOptions = legal_entities.map((x) => {
    const { id, legal_name: name } = x.attributes

    return (
      <Selector.Option key={id} value={id} label={name} searchValue={name}>
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium">
            {name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  return (
    <Selector.Popover
      inputStyle="tags"
      label={i18n.t('settings.permissions.visibility.choices.dynamic_group_options.legal_entity')}
      blankLabel={i18n.t('common.empty')}
      allSelectedLabel={i18n.t('common.all')}
      placeholder={i18n.t('common.select')}
      searchPlaceholder={i18n.t('common.search')}
      icon="briefcase"
      value={legalEntitiesIds ? legalEntitiesIds : []}
      onChange={(ids) => handleChangeLegalEntities(ids as number[])}
      onToggle={(isOpen) => !isOpen}
      isMultiSelect
      maxHeight="s400"
    >
      {legalEntityOptions}
    </Selector.Popover>
  )
}
export default observer(LegalEntityMultiselector)
